
import axios from 'axios';
import { useEffect, useState } from 'react';
import './App.css';
import Project from './Component/Project';
import ScrollReveal from './Custom Hook/ScrollReveal';

const API = "https://raw.githubusercontent.com/kvnal/portfolio-v1.0/API/data.json";

function App() {
  const [limit, setLimit] = useState(6);
  const [mobileDevice, setMobileDevice] = useState(false);
  var [preloader, setPreloader] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    // mobile detect
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
      setLimit(4);
      setMobileDevice(false);
    }


    async function areFontsReady() {
      await (document).fonts.ready;
      setTimeout(() => {
        setPreloader(false);
      }, 1000);
    }
    
    axios.get(API).then(res => {
      setData(res.data.data);
      areFontsReady();
    });

  }, []);

  if (preloader)
    return (
      <div className="preloader bg-white min-h-screen flex justify-center items-center flex-col">
        <div className="preloader-container h-40 w-40"></div>
        <div className="font-mono font-semibold">{window.location.host}</div>
      </div>
    );
  return (<>{data &&

    <div className="bg-secondary  " >
      <div className="bg-white mx-2 border-2 border-black border-t-0 border-b-0
      sm:mx-40
      ">

        <div className="bg-black h-4
        sm:h-12
        ">
        </div>

        <div className="mt-4 border-black border-t-2 ">
          <section className="flex flex-wrap  min-h-screen items-center border-b-2 border-black mb-2">

            <div className=" ml-4 pb-20
            sm:ml-20
            sm:pb-4
            ">
              <span className=" block  font-Firacode font-semibold mb-2 tracking-tight  text-gray-800
              ">{data.info.title1}</span>
              <h2 className="test font-Manrope font-bold text-4xl text-primary mb-4 
              sm:text-5xl">{data.info.name}</h2>
              <h4 className=" font-Manrope font-bold text-xl text-gray-800 mb-2
              sm:text-2xl
              ">{data.info.title2}</h4>
              <span className=" block font-Manrope font-normal text-gray-800 mb-2 w-4/5 
              sm:w-3/4
              ">{data.info.description}</span>

              <a target="_blank"  href={data.info.resume.external} className="underline font-semibold  font-Manrope text-primary hover:text-black">{data.info.resume.title}</a>

              <div className=" mt-12 border-white flex mb-4 text-gray-800  " >
                {/* github */}
                <a target="_blank"  className="mr-4 hover:text-primary   " href={data.socials.github}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-github" viewBox="0 0 16 16">
                    <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
                  </svg>
                </a>

                {/* linkedin */}
                <a target="_blank"  className="mr-4 hover:text-primary   " href={data.socials.linkedin}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-linkedin" viewBox="0 0 16 16">
                    <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                  </svg>
                </a>

                {/* instagram */}
                <a target="_blank"  className="mr-4 hover:text-primary   " href={data.socials.instagram}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-instagram" viewBox="0 0 16 16">
                    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
                  </svg>
                </a>

                {/* twitter */}
                <a target="_blank"  className="mr-4 hover:text-primary   " href={data.socials.twitter}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-twitter" viewBox="0 0 16 16">
                    <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z" />
                  </svg>
                </a>
              </div>

              <div >
                {/* className="
            flex justify-center
            mt-20
            mr-4
            sm:block
            sm:mt-0
            " */}
                <button className=" text-black border-2 border-black font-Manrope font-bold px-6 py-1 mt-6 hover:text-primary hover:border-primary"
                > <a href="#project">Checkout My Work</a></button>
              </div>
            </div>


          </section>
        </div>

        {/* SKILLS */}
        <div className="mt-2 border-black border-t-2 ">

          {/* <section className="flex flex-wrap  min-h-screen items-center border-b-2 border-black mb-2"> */}
          <ScrollReveal>
          <section className="mt-10 border-b-2 border-black mb-2">
            <div className=" ml-4 pb-16
            sm:ml-20
            ">
              <span className="block font-Manrope pr-4 font-semibold mb-2">{data.skills.title}</span>

              <div className="mt-4">
                <ul className="grid grid-cols-2
                sm:w-1/2
                ">
                  {(data.skills.list).map(Element => (
                    <li className="font-Firacode font-bold "><span className="pr-2 text-primary">▸</span>{Element}</li>
                  ))}
                </ul>
              </div>
            </div>

          </section>
          </ScrollReveal>

          <section className="mt-10 border-b-2 border-black mb-2 pt-10" id="project">
          <ScrollReveal>
            <h4 className="text-center font-Manrope font-semibold mb-4 text-xl tracking-wider">{data.projects.title}</h4>
            {(data.projects.featured) &&
              <>
                <h4 className="text-center font-Bebasneue mb-4 text-xl tracking-wider text-primary underline">Featured Projects</h4>
                <div className=" mx-4 pb-10 ">
                  <Project Data={data.projects.featured} show={4} col={2} />
                </div>
              </>
            }
          </ScrollReveal>

            <div className="border-t-2 border-black pb-10"></div>
          <ScrollReveal>

            <h4 className="text-center font-Bebasneue mb-4 text-xl tracking-wider text-primary underline">Other Noteworthy Projects</h4>
            <div className=" mx-4 pb-6" >
              <Project Data={data.projects.projects} show={limit} col={3} />
            </div>
            <div className="flex justify-center pb-8">
              {(data.projects.projects.length > limit) &&
                <button className=" text-black border-2 border-black font-Manrope font-bold px-6 py-1 hover:text-primary hover:border-primary"
                  onClick={() => setLimit(data.projects.projects.length)}
                >Show More</button>
              }
              {data.projects.projects.length == limit &&
                <button className=" text-black border-2 border-black font-Manrope font-bold px-6 py-1 hover:text-primary hover:border-primary"
                  onClick={() => setLimit((mobileDevice ? 4 : 6))}
                >Show Less</button>
              }
            </div>
          </ScrollReveal>
          </section>

          {data.awards[0].list &&
            <>
              <div className="border-t-2 border-black pb-10"></div>
              <ScrollReveal>
              <section className="mt-10 border-b-2 border-black  pb-20">
                <h4 className="text-center font-Manrope font-semibold mb-4 text-xl tracking-wider">{data.awards.title}</h4>
                <h4 className="text-center font-Bebasneue mb-4 text-xl tracking-wider underline text-primary">{data.awards[0].title}</h4>
                <div className="text-center mx-4">
                  <ul>
                    {
                      (data.awards[0].list).map(Element => (
                        <li className="font-Manrope  mb-2">
                          <span>
                            {Element.title}

                            {/*                           
                          <a className="inline pl-2 text-primary" href={Element.external}>
                          <svg className="inline" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z" />
                            <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z" />
                          </svg>
                          </a> */}
                          </span>

                        </li>
                      ))
                    }
                  </ul>

                </div>
              </section>
              </ScrollReveal>
            </>
          }
        </div>




        <div className="">
          <section className="bg-secondary-layer-2 pt-10 pb-20  border-b-2 border-black">
        <ScrollReveal>
            <div className="flex flex-wrap justify-center flex-col">
              <h1 className="text-center mb-2 text-black font-Manrope  font-bold
              text-2xl
              sm:text-4xl
              ">{data.contact.title}</h1>
              <p className="text-center mx-4 text-gray-700 font-Manrope  font-semibold 
              sm:mx-40
              ">
                {data.contact.description}</p>

              <div className="mx-auto mt-8 ">
                <a className=" text-black border-2 border-black font-Manrope font-bold px-6 py-1 hover:bg-black hover:text-secondary-layer-2"
                href={`mailto:${data.socials.mail}`}
                >{data.contact.buttonTitle}</a>
              </div>
            </div>
          </ScrollReveal>
          </section>

        </div>

        <div className="bg-black p-4 pb-10">
          {/* {mobileDevice && */}
          {
            <div className="mt-4 border-white flex  justify-center mb-4 text-secondary-layer-2 ">
              {/* github */}
              <a target="_blank"  className="  mx-4" href={data.socials.github}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-github" viewBox="0 0 16 16">
                  <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
                </svg>
              </a>

              {/* linkedin */}
              <a  target="_blank"  className="  mx-4" href={data.socials.linkedin}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-linkedin" viewBox="0 0 16 16">
                  <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                </svg>
              </a>

              {/* linkedin */}
              <a  target="_blank"  className="  mx-4" href={data.socials.instagram}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-instagram" viewBox="0 0 16 16">
                  <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
                </svg>
              </a>

              {/* linkedin */}
              <a target="_blank" className="  mx-4" href={data.socials.twitter}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-twitter" viewBox="0 0 16 16">
                  <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z" />
                </svg>
              </a>
            </div>}


          <h4 className="text-secondary-layer-2 pt-4 text-center font-Firacode text-xs tracking-wider sm:pt-2">Designed &amp; Built by Kunal Singh</h4>

        </div>
      </div>

    </div>
  }</>
  );
}

export default App;
